import { useBoundarySelectContext } from "../../boundarySelection/BoundarySelectContext";
import { Vector } from "../../reactOL/layers";
import { useEffect } from "react";
import { useViewContext } from "../../../context/View/ViewContext";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { anonPaths } from "../../auth/AuthProvider";

interface BoundarySelectionLayerProps {
  mapContainerRef: React.RefObject<HTMLDivElement>;
  setSize?: (size: [number, number]) => void;
}

const BoundarySelectionLayer = ({
  mapContainerRef,
  setSize,
}: BoundarySelectionLayerProps) => {
  const { vectorSource, viewExtent, boundaries } = useBoundarySelectContext();

  const { view } = useViewContext();
  const urlLayer = useParams().layer;
  const { pathname } = useLocation();
  const isAnonRoute = anonPaths.some((path) =>
    pathname.toLowerCase().startsWith(path),
  );

  useEffect(() => {
    if (setSize) {
      setSize([
        mapContainerRef.current!.offsetWidth,
        mapContainerRef.current!.offsetHeight,
      ]);
    }
  }, [boundaries, mapContainerRef, setSize, view, urlLayer, isAnonRoute]);

  useEffect(() => {
    if (viewExtent) {
      view.fit(viewExtent, {
        padding: [50, 50, 50, 50],
        duration: 500,
      });
    }
  }, [viewExtent, view]);

  return <Vector name="boundaries" source={vectorSource} />;
};

export default BoundarySelectionLayer;
